import { ShopifyCart } from "../../types";
import { fetchSymbol } from "../fetch/fetch-helper";

const endpoint = '/cart.js';

export async function get(noIntercept?: boolean): Promise<ShopifyCart> {
  const res = await window[fetchSymbol].getJSON<ShopifyCart>(endpoint, undefined, noIntercept);
  return res;
}
